export default __webpack_public_path__ + "static/5-f27a61807f94d8ba712a9af0a5c5904e.jpeg";